import { List, Map as ImmutableMap, Record as ImmutableRecord } from 'immutable';
export default class FlowValidation extends ImmutableRecord({
  FLOW: List(),
  ACTION: ImmutableMap(),
  // Lists of ValidationError records keyed by actionId
  isValid: true
}, 'FlowValidation') {
  getActionsWithErrors() {
    return List(this.getActionErrors().keySeq().map(actionId => actionId));
  }
  getErrorsByActionId(actionId) {
    if (actionId) {
      return this.ACTION.get(actionId) || List();
    }
    return List();
  }
  getAllActionErrors() {
    const allActionErrors = this.get('ACTION').toList().flatten(1);
    return allActionErrors.sortBy(error => error.get('actionId'));
  }
  getFlowErrors() {
    return this.get('FLOW');
  }
  getActionErrors() {
    return this.get('ACTION');
  }
  getIsValid() {
    return this.get('isValid');
  }
}